import React, {Ref} from 'react';

import {useRef} from 'react';
import {CSSTransition, TransitionStatus} from 'react-transition-group';
import {CSSTransitionProps} from 'react-transition-group/CSSTransition';

type Props = CSSTransitionProps & {
    children: (transitionStatus: TransitionStatus) => React.ReactNode;
};

// https://github.com/reactjs/react-transition-group/issues/918
export function CSSTransitionWithRef({children, ...restProps}: Props) {
    const ref = useRef<HTMLElement>(null);

    return (
        <CSSTransition nodeRef={ref} {...restProps}>
            {(transitionStatus) => (
                <div ref={ref as Ref<HTMLDivElement | null>}>{children(transitionStatus)}</div>
            )}
        </CSSTransition>
    );
}
